'use client'

import { createContext, useContext, useState, type ReactNode } from 'react'

import { type CatalogSearchParams } from '../lib/search-params'
import { CatalogFiltersProvider } from './catalog-filters-context'

/**
 * Строка поиска стоит над списком, а фильтры — в боковой колонке. Общее состояние нужно,
 * чтобы набранный, но ещё не отправленный текст не пропадал при клике по фильтру.
 */
const CatalogQueryContext = createContext<{ query: string; setQuery: (value: string) => void } | null>(null)

/**
 * Заодно поднимает держатель отбора: тот подмешивает набранный текст в каждый новый адрес,
 * поэтому обязан стоять внутри — вложенность гарантирует порядок.
 */
export const CatalogQueryProvider = ({ params, children }: { params: CatalogSearchParams; children: ReactNode }) => {
  const [query, setQuery] = useState(params.query ?? '')

  return (
    <CatalogQueryContext value={{ query, setQuery }}>
      <CatalogFiltersProvider serverParams={params}>{children}</CatalogFiltersProvider>
    </CatalogQueryContext>
  )
}

export const useCatalogQuery = () => {
  const context = useContext(CatalogQueryContext)
  if (!context) {
    throw new Error('useCatalogQuery используется вне CatalogQueryProvider')
  }

  return context
}
